import { useAdminPermissions } from "../../hooks/useAdminPermissions";
import "../../pages/OpsPermissionsPage.css";

export default function AdminModuleGate({ permission, children }) {
  const { loading, canAccessModule } = useAdminPermissions();

  if (loading) {
    return <div className="ops-loading-state">Checking module access…</div>;
  }

  if (!canAccessModule(permission)) {
    return (
      <div className="ops-screen-container">
        <div className="ops-rbac-denied">
          <span aria-hidden="true">🔒</span>
          <h2>Module access restricted</h2>
          <p>Your assigned admin role does not include access to this module.</p>
        </div>
      </div>
    );
  }

  return children;
}
